import moment from 'moment';
import { tomorrowDateGmt } from '../../../Filters/FilterComponents/DateFilter';
import { FILTER_VALUES, TRACKING_LABELS } from '../../constants';
import { trackEvent } from '../../../../../components/Analytics/TrackedClick';

const FLEX_LEAGUE = 'flex_league';

export const checkMoreFiltersActive = (filters, showTennisFilters, showPickleballFilters) => {
    if (!filters) {
        return false;
    }

    const hasActiveValues = (obj) => obj && Object.values(obj).indexOf(true) > -1;

    return (
        hasActiveValues(filters?.eventTeamTypes) ||
        hasActiveValues(filters?.genders) ||
        hasActiveValues(filters?.eventTypes && Object.fromEntries(
            Object.entries(filters.eventTypes).filter(([key]) => key !== FLEX_LEAGUE),
        )) ||
        hasActiveValues(filters?.ballTypes) ||
        hasActiveValues(filters?.eventUtrTypes) ||

        (filters?.prizeMoneyMin && filters?.prizeMoneyMin > 1) ||
        (filters?.prizeMoneyMax && filters?.prizeMoneyMax < 7) ||

        filters?.utrMin > 1 ||
        (filters?.utrMax < 16 && showTennisFilters && !showPickleballFilters) ||
        (filters?.utrMax < 10 && showPickleballFilters && !showTennisFilters) ||

        (filters?.startDate && !moment(filters?.startDate).isSame(tomorrowDateGmt, 'day')) ||
        filters?.endDate ||

        // Check if Past date filter is selected
        filters?.dateRange === FILTER_VALUES.PAST
    );
};

export const checkAllEventSeriesFiltersActive = (filters) => {
    if (!filters) {
        return false;
    }

    const isToursActive = filters?.tours && Object.values(filters.tours).some(value => value);
    const isFlexLeagueActive = filters?.eventTypes?.flex_league;

    return isToursActive || isFlexLeagueActive;
};

export const createAllEventSeriesOptions = (tourOptions = []) => {
    return [
        { value: FLEX_LEAGUE, label: 'UTR Flex Leagues' },
        ...tourOptions,
    ];
};

export const isAllEventSeriesOptionSelected = (optionValue, filters, localFilterInputs = null) => {
    // Use local state if available, otherwise fall back to filters
    const sourceData = localFilterInputs ?? {};

    if (optionValue === FLEX_LEAGUE) {
        return sourceData[FLEX_LEAGUE] ?? filters?.eventTypes?.flex_league ?? false;
    }

    return sourceData[optionValue] ?? filters?.tours?.[optionValue] ?? false;
};

export const trackAllEventSeriesFilters = (filters, localFilterInputs = null) => {
    const tourFilters = localFilterInputs || filters?.tours || {};
    const tourFilterKeys = Object.keys(tourFilters).filter(key => tourFilters[key] === true);

    const isFlexLeagueActive = localFilterInputs
        ? localFilterInputs.flex_league
        : filters?.eventTypes?.flex_league;

    if (isFlexLeagueActive) {
        tourFilterKeys.push('Flex League');
    }

    if (tourFilterKeys.length > 0) {
        const { EVENT_SERIES, CLIENT, EVENT_NAME } = TRACKING_LABELS;
        const filterValueString = tourFilterKeys.join(', ');
        trackEvent(EVENT_NAME, {
            filter_name: EVENT_SERIES,
            filter_value: filterValueString,
            client: CLIENT,
        });
    }
};
